import React, { Component } from "react";
import { Helmet } from "react-helmet";
import _ from "lodash";
import styled from "styled-components";
import Papa from 'papaparse';

import Link from '@material-ui/core/Link';
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import CircularProgress from "@material-ui/core/CircularProgress";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";

import PageHeader from "../../components/PageHeader";
import { sheet1Spec, sheet2Spec } from '../../../utils/csv';

import {
  importUploadedRoomsFromFirebase,
  importUploadedProjectsFromFirebase,
} from "../../../api";
import storage from "../../../engine/storage";

const BlockContent = styled.div`
  min-height: 100%;
  display: flex;
  flex-direction: column;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1em;
`

const SuccessWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 6px 16px;
  font-size: 0.875rem;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 400;
  line-height: 1.43;
  border-radius: 4px;
  letter-spacing: 0.01071em;
  color: rgb(30, 70, 32);
  background-color: rgb(237, 247, 237);
  box-shadow: none;
  width: 188px;
`;

export default class Rooms extends Component {
  state = {
    loading: false,
    success: false,
    importError: null,
  };

  validateCSV = (file, spec) => {
    return new Promise((resolve, reject) => {
      Papa.parse(file, {
        complete: (results, file) => {
          const header = results.data[0];
          if (_.isEqual(header, spec)) resolve(null);
          else {
            reject({
              message: `Header mismatch`,
              data: {
                expecting: spec,
                receiving: header
              }
            });
          }
        }
      })
    })
  }

  handleFileChange = async (e, type) => {

    console.log('handleFileChange');
    try {
      this.setState({
        success: false,
        loading: true,
        importError: null,
      })
      const target = e.target;
      if (_.get(target, "files.0")) {

        const file = _.get(target, "files.0");

        const spec = type === 'room' ? sheet2Spec : sheet1Spec; 
        await this.validateCSV(file, spec);
       
        // this.setState({
        //   loading: true,
        //   success: false,
        // });
        const uploadedFileName =
          type === "room" ? "uploaded-rooms.csv" : "uploaded-projects.csv";
        const importUploadedFileFn =
          type === "room"
            ? importUploadedRoomsFromFirebase
            : importUploadedProjectsFromFirebase;

        storage
          .ref(uploadedFileName)
          .put(_.get(target, "files.0"))
          .then(async (snapshot) => {
            importUploadedFileFn(uploadedFileName)
              .then((result) => {
                this.setState({
                  loading: false,
                  success: true,
                });
              })
              .catch((error) => {
                this.setState({
                  loading: false,
                  success: false,
                });
              });
          })
          .catch((error) => {
            console.log("Upload error??", error);
            this.setState({
              loading: false,
              success: false,
            });
          });
      }
    } catch (e) {
      this.setState({
        loading: false,
        success: false,
        importError: e
      });
    }
  };

  render() {
    const { loading, success, importError } = this.state;
    return (
      <BlockContent>
        <Helmet>
          <title>Import | MI Treasure</title>
        </Helmet>
        <PageHeader title="Import" />
        {!success && importError !== null && (
          <div style={{ color: 'rgb(244, 67, 54)', border: `1px solid rgb(244, 67, 54)`, padding: 10 }}>
            <h5>{_.get(importError, 'message')}</h5>
            <div style={{ fontSize: '0.8em', marginBottom: 5 }}>Expecting: {_.join(_.get(importError, 'data.expecting'))}</div>
            <div style={{ fontSize: '0.8em' }}>Receiving: {_.join(_.get(importError, 'data.receiving'))}</div>
          </div>
        )}
        <Row>
          <Button
            variant="extendedFab"
            component="label"
            color="primary"
            style={{ width: "280px" }}
          >
            <AddIcon /> IMPORT SHEET1 FROM CSV
            <input
              type="file"
              onChange={(e) => this.handleFileChange(e, "project")}
              hidden
            />
          </Button>
          <Link href="/template_sheet1.csv" target="_blank">Template file (sheet1.csv)</Link>
        </Row>
        <Row>
          <Button
            variant="extendedFab"
            component="label"
            color="primary"
            style={{ width: "280px" }}
          >
            <AddIcon /> IMPORT SHEET2 FROM CSV
            <input
              type="file"
              onChange={(e) => this.handleFileChange(e, "room")}
              hidden
            />
          </Button>
          <Link href="/template_sheet2.csv" target="_blank">Template file (sheet2.csv)</Link>
        </Row>
        {loading && <CircularProgress color="primary" />}
        {success && (
          <SuccessWrapper>
            <CheckCircleOutlineIcon
              color="#5bb660"
              style={{ marginRight: "10px" }}
            />
            Import CSV Success
          </SuccessWrapper>
        )}
      </BlockContent>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/screens/Import/index.js